import BaseComponent from "../BaseComponent";
import TextInput from "components/Properties/InputComponents/TextInput";

const PortalComponent = ({pId, textOnChange}) => {
  return (
    <BaseComponent title="Portal" foldable={false}>
      <TextInput name="pId" value={pId} textOnChange={textOnChange} placeholder="Enter PID" />
    </BaseComponent>
  );
};

export default PortalComponent;
